import { ReactNode } from "react";
import { Account, County, Discount, State, SubscriptionStatus } from "@shared/models";
import { PayPerLead } from "@shared/models/PayPerLead";
import { StateIdType } from "@containers/PayPerLead/interface/Actions";

export interface LeadPriceResponse {
  price: number;
}

export interface PayPerLeadSubscription {
  id?: number;
  price?: number;
  is_active?: boolean;
  is_paused?: boolean;
  renew?: boolean;
  draft?: {
    id: number;
  };
  created_at?: Date | string;
  paused_at?: Date | string;
  cancelled_at?: Date | string;
  next_billing_at?: Date | string;
  activated_at?: Date | string;
  updated_at?: Date | string;
  start_date?: Date;
  end_date?: Date;
  items: SubscriptionStateItem[];
  coupon: string | null;
  quote?: ChargeQuote;
  lock?: {
    created_at?: Date | string;
  };
  cancellation_reason?: string;
  cancellation_reason_other?: string;
  total_leads?: number;
  leads?: PayPerLead[];
  state?: State;
  counties?: County[];
  account?: Account;
  cbStatus?: SubscriptionStatus;
  remaining_balance?: number;
  discounts?: Discount[];
  chargebee_subscription_id?: string;
  deal_id?: string;
  hubspot_deal_id?: string;
}

export interface ChargeQuote {
  subtotal: number;
  credits: number;
  discount: number;
  total: number;
}

export interface SubscriptionStateItem {
  id?: number;
  state_id?: number | StateIdType;
  state_id_touched?: boolean;
  state?: State;
  counties: SubscriptionCountyItem[];
  counties_touched?: boolean;
  force_total_per_county: boolean;
  leads_total?: number;
  leads_total_touched?: boolean;
  all_counties: boolean;
  all_states?: boolean;
  isDuplicate?: boolean;
  price?: number;
  unassigned_leads?: number;
  unassigned_leads_on_cancel?: number;
  paid_amount?: number;
}

export interface SubscriptionCountyItem {
  id?: number;
  county_id: number;
  name?: string;
  total_leads?: number;
  touched?: boolean;
  unassigned_leads?: number;
  price?: number;
  state_id?: number;
  state?: State;
}

export enum PayPerLeadSubscriptionStatus {
  Active = "Active",
  Inactive = "Inactive",
  PaymentDue = "Payment Due",
}

export interface PayPerLeadSubscriptionWithCustomer extends PayPerLeadSubscription {
  total_leads?: number;
  total_counties?: number;
  location?: string;
  account: Account;
  items: SubscriptionStateItem[];
  leads?: PayPerLead[];
  status?: PayPerLeadSubscriptionStatus;
}

export interface CheckoutLineData {
  label?: ReactNode;
  leads: number;
  perLead?: number;
  price: number;
}

export interface CheckoutRowData {
  subitems: CheckoutLineData[];
  subtotal: CheckoutLineData;
}

export interface CheckoutData {
  rows: CheckoutRowData[];
  total: CheckoutLineData;
}

export interface PayPerLeadStatistics {
  leadsOrdered: number;
  leadsDelivered: number;
  disputes: number;
  totalPrice: number;
  customers: Account[];
  states: number[];
  counties: number[];
  dates: string[];
}

export interface PayPerLeadPurchaseInfo {
  paid: boolean;
  hasPendingInvoice: boolean;
  leftToPay: number;
  paymentAmount: number;
}

export interface PayPerLeadSubscriptionStatistics {
  leads_total: number;
  unassigned_leads: number;
  price: number;
}
